import * as queryString from 'query-string';

import { UrlParamKeys } from '~commonInfra/url/UrlParamKeys';

/**
 * Builds the Task Details URL for a background job's task, carrying the originating
 * job id as a query param. Shared by the Jobs page Job ID cell and the "View Details"
 * action-menu saga so the two navigation paths never diverge.
 */
export function buildTaskDetailsUrl(jobsUrl: string, taskLuid: string, jobId: number | string): string {
  return `${jobsUrl}/task/${encodeURIComponent(taskLuid)}?jobId=${encodeURIComponent(String(jobId))}`;
}

/**
 * Parses the `jobId` query param from a Task Details route's `location.search`.
 * Tolerates an absent or malformed param, returning `null` rather than throwing.
 */
export function parseJobIdQueryParam(locationSearch: string): string | null {
  const parsed = queryString.parse(locationSearch || '');
  const jobId = parsed[UrlParamKeys.JobId];
  return typeof jobId === 'string' ? jobId : null;
}
